import { Box } from "@mui/material";
import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import AppLayout from "./components/layout/AppLayout";
import PublicLayout from "./components/layout/PublicLayout";
import SelectUserPage from "./components/SelectUserPage";
import AdminConfigPage from "./pages/admin/AdminConfigPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminUsersPage from "./pages/admin/AdminUsersPage";
import AktualityPage from "./pages/AktualityPage";
import ErrorPage from "./pages/ErrorPage";
import EmailPasswordPage from "./pages/EmailPasswordPage";
import FakturyPage from "./pages/FakturyPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import LoginPage from "./pages/LoginPage";
import MfaSettingsPage from "./pages/MfaSettingsPage";
import NewPasswordPage from "./pages/NewPasswordPage";
import OdbernaMistaPage from "./pages/OdbernaMistaPage";
import PozadavkyPage from "./pages/PozadavkyPage";
import RegisterPage from "./pages/RegisterPage";
import ProfilePage from "./pages/UserPage";
import VerifyCodePage from "./pages/VerifyCodePage";
import ZalohyPage from "./pages/ZalohyPage";
import AdminProtectedRoute from "./routes/AdminProtectedRoute";
import ProtectedRoute from "./routes/ProtectedRoute";

// Veřejné cesty
const publicRoutes = [
  { path: "login", element: <LoginPage /> },
  { path: "register", element: <RegisterPage /> },
  { path: "verify-code", element: <VerifyCodePage /> },
  { path: "email-password", element: <EmailPasswordPage /> },
  {
    path: "select-user",
    element: <SelectUserPage />,
  },
  {
    path: "forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "new-password",
    element: <NewPasswordPage />,
  },
];

// Chráněné cesty
const protectedRoutes = [
  { path: "mfa-settings", element: <MfaSettingsPage /> },
  { path: "aktuality", element: <AktualityPage /> },
  { path: "faktury", element: <FakturyPage /> },
  { path: "zalohy", element: <ZalohyPage /> },
  { path: "odberna-mista", element: <OdbernaMistaPage /> },
  // { path: "platby", element: <PlatbyPage /> },
  { path: "pozadavky", element: <PozadavkyPage /> },
  { path: "ucet", element: <ProfilePage /> },
];

const userTabConfig = [
  { label: "Aktuality", path: "/zvk/aktuality" },
  { label: "Faktury", path: "/zvk/faktury" },
  { label: "Zálohy", path: "/zvk/zalohy" },
  { label: "Odběrná místa", path: "/zvk/odberna-mista" },
  // { label: "Platby", path: "/zvk/platby" },
  { label: "Požadavky", path: "/zvk/pozadavky" },
  { label: "Návod", path: "/zvk/navod" },
];

const adminTabConfig = [
  { label: "Odběratele", path: "/admin/users" },
  { label: "Konfigurace", path: "/admin/config" },
];

const router = createBrowserRouter([
  {
    path: "/",
    element: <PublicLayout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Navigate to="/login" replace /> },
      ...publicRoutes,
    ],
  },
  {
    path: "zvk",
    element: (
      <ProtectedRoute>
        <AppLayout tabConfig={userTabConfig} />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Navigate to="aktuality" replace /> },
      ...protectedRoutes,
    ],
  },
  {
    path: "admin",
    element: (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          bgcolor: "background.default",
          color: "text.primary",
        }}
      >
        <Box
          sx={(theme) => ({
            flex: 1,
            backgroundColor: theme.palette.background.default,
          })}
        >
          <Outlet />
        </Box>
      </Box>
    ),
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Navigate to="/admin/login" replace /> },
      {
        path: "login",
        element: <AdminLoginPage />,
      },
      {
        path: "",
        element: (
          <AdminProtectedRoute>
            <AppLayout tabConfig={adminTabConfig} />
          </AdminProtectedRoute>
        ),
        children: [
          {
            path: "users",
            element: <AdminUsersPage />,
          },
          {
            path: "config",
            element: <AdminConfigPage />,
          },
        ],
      },
    ],
  },
  /* fallback */
  { path: "*", element: <Navigate to="/login" replace /> },
]);

export default router;
